import { EditableText, defineBlock } from "eddev/blocks"
import { Col, Container, Grid } from "@components/layout/Grid"
import { Button } from "@components/atoms/Button"
import { FooterCTA } from "@components/atoms/FooterCTA"
import { Heading } from "@components/atoms/Heading"
import { useIsMobile } from "@hooks/useViewportDerived"

export const meta: BlockMeta = {
  title: "Footer CTA",
  category: "common",
  icon: "star-filled",
  keywords: ["cta"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("general/footer-cta", (props) => {
  const isMobile = useIsMobile()

  return (
    <Container>
      <Grid>
        <Col initial={12}>
          <FooterCTA className="[&_h4]:type-title-xs md:[&_h4]:type-title-s">
            <EditableText as="h4" placeholder="Enter text..." store="text" />

            {props.link?.url && (
              <Button
                color="outline"
                size="medium"
                icon={props.link?.target ? "ARROW_UP_RIGHT" : "ARROW_RIGHT"}
                iconStyle="right"
                href={props.link.url}
                target={props.link?.target ? "_blank" : undefined}
              >
                {props.link?.title}
              </Button>
            )}
          </FooterCTA>
        </Col>
      </Grid>
    </Container>
  )
})
